export default (theme) => ({
  eventContainer: {},
  eventViewerContainer: {
    maxWidth: '600px',
    margin: '0 auto',
    // min-width: 0 lets this Grid item shrink so content wraps instead of overflowing.
    minWidth: 0,
  },
  eventHeader: {
    margin: '20px 0 40px',
    padding: '20px 0',
    textAlign: 'center',
  },
  eventHeaderSectionQuestion: {
    margin: '15px 0',
    padding: '20px 0',
    textAlign: 'center',
  },
  eventResponseOptions: {},
  eventResponseInput: {},
  eventCheckboxOptions: {},
  eventCheckboxLabel: {
    '& span': {
      fontSize: '1.1em !important',
    },
  },
  eventFilterContainer: {
    margin: '0 0 15px',
  },
  eventActionButtons: {},
  eventActionButtons_ResponsiveHeight: {
    'main.is_mobile_height &': {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'white',
      padding: '0 20px',
      // Above page content (incl. footer controls), below dialogs and snackbars.
      zIndex: theme.zIndex.appBar,
    },
  },
  eventDateRangeOption: {
    width: '100%',
    margin: '0',
  },
  eventOption: {
    margin: '0 0 25px',
  },
  eventListOptions_mobile: {},
  eventActionButtons_mobile: {},
  eventInlineInputAndButton: {
    display: 'flex',
    marginBottom: '15px',
    '& button': {
      marginLeft: '15px',
    },
  },
  eventSubmissionDisclaimer: {
    padding: '0 20px',
    marginTop: '30px',
  },
  eventPaperSection: {
    padding: '20px 20px 0.1px 20px',
    marginBottom: '20px',
  },
  eventPaperTitle: {
    marginBottom: '20px',
    '&:focus': { outline: 'none' },
  },
  eventPaperCaption: {
    marginBottom: '10px',
  },
  eventPaperCaption_italic: {
    fontSize: '.8em',
    fontStyle: 'italic',
  },
  eventTimeOfDayButton: {
    marginBottom: '2px',
  },
  eventFormGroupDayOfWeek: {
    marginTop: '10px',
  },
  eventOptionMarginBottom10: {
    marginBottom: '10px',
  },
  eventGridMobileSpacing: {
    marginBottom: '0',
  },
});
